<template>
    <div class="w-full lg:a-w-1100 mx-auto">
        <div class="w-full px-80 py-140 lg:a-p-0 lg:a-h-280 mt-80 lg:a-mt-160 flex-center relative">
          <h2 class="text-80 leading-96 lg:a-text-56 lg:a-leading-64 font-semibold text-sub text-center" v-html="t('member_index.register_guide.title')"></h2>
          <img class="w-34 h-54 lg:a-w-34 lg:a-h-54 absolute left-56 lg:left-0 top-0" src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/1_d4621f27-b474-43ea-902e-f00f790cf09b.png?v=1670915016" alt="">
          <img class="w-46 h-66 lg:a-w-46 lg:a-h-66 absolute right-56 lg:right-0 bottom-0" src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/2_55109115-cdac-4786-9031-e7168f04d355.png?v=1670915016" alt="">
        </div>

        <section id="gallery" class="lg:a-w-800 mx-auto">
          <!-- step 1 -->
          <div class="guide-step">
            <h3>{{ t('member_index.register_guide.step_1_title') }}</h3>
            <h5>{{ t('member_index.register_guide.step_1_subtitle_1') }}</h5>

            <p v-html="t('member_index.register_guide.step_1_content_1')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_1_img_1_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_1_img_1_mb')" alt="">
            
            <p v-html="t('member_index.register_guide.step_1_content_2')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_1_content_3')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_1_content_4')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_1_img_2_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_1_img_2_mb')" alt="">
            
            <p v-html="t('member_index.register_guide.step_1_content_5')"></p>

            <h5 class="!lg:j-mt-120">{{ t('member_index.register_guide.step_1_subtitle_2') }}</h5>
            <p v-html="t('member_index.register_guide.step_1_content_6')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_1_content_7')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_1_img_3_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_1_img_3_mb')" alt="">
          
            <p v-html="t('member_index.register_guide.step_1_content_8')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_1_img_4_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_1_img_4_mb')" alt="">
          
            <p v-html="t('member_index.register_guide.step_1_content_9')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_1_img_5_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_1_img_5_mb')" alt="">
          
            <p v-html="t('member_index.register_guide.step_1_content_10')"></p>
            <img v-if="t('member_index.register_guide.step_1_img_6_pc')" class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_1_img_6_pc')" alt="">
            <img v-if="t('member_index.register_guide.step_1_img_6_mb')" class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_1_img_6_mb')" alt="">
          
            <p v-html="t('member_index.register_guide.step_1_content_11')"></p>
          </div>

          <!-- step 2 -->
          <div class="guide-step">
            <h3>{{ t('member_index.register_guide.step_2_title') }}</h3>
            <p v-html="t('member_index.register_guide.step_2_content_1')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_2_img_1_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_2_img_1_mb')" alt="">
          </div>

          <!-- step 3 -->
          <div class="guide-step">
            <h3>{{ t('member_index.register_guide.step_3_title') }}</h3>
            <p v-html="t('member_index.register_guide.step_3_content_1')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_3_content_2')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_3_img_1_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_3_img_1_mb')" alt="">
          
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_3_img_2_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_3_img_2_mb')" alt="">
          
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_3_img_3_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_3_img_3_mb')" alt="">
          
            <p v-html="t('member_index.register_guide.step_3_content_3')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_3_img_4_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_3_img_4_mb')" alt="">
          
            <p v-html="t('member_index.register_guide.step_3_content_4')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_3_content_5')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_3_content_6')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_3_content_7')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_3_content_8')"></p>
          </div>

          <!-- step 4 -->
          <div class="guide-step">
            <h3>{{ t('member_index.register_guide.step_4_title') }}</h3>
            <p v-html="t('member_index.register_guide.step_4_content_1')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_4_img_1_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_4_img_1_mb')" alt="">
          
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_4_img_2_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_4_img_2_mb')" alt="">
          
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_4_img_3_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_4_img_3_mb')" alt="">
          
            <p v-html="t('member_index.register_guide.step_4_content_2')"></p>
            <br class="block lg:hidden"/>
            <p v-html="t('member_index.register_guide.step_4_content_3')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_4_img_4_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_4_img_4_mb')" alt="">
          </div>

          <!-- step 5 -->
          <div class="guide-step">
            <h3>{{ t('member_index.register_guide.step_5_title') }}</h3>
            <p v-html="t('member_index.register_guide.step_5_content_1')"></p>
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_5_img_1_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_5_img_1_mb')" alt="">
            
            <img class="lazyload hidden lg:block cursor-pointer" data-fancybox-pc :data-src="t('member_index.register_guide.step_5_img_2_pc')" alt="">
            <img class="lazyload block lg:hidden cursor-pointer" data-fancybox-mb :data-src="t('member_index.register_guide.step_5_img_2_mb')" alt="">
            <p v-html="t('member_index.register_guide.step_5_content_2')"></p>
          </div>
        </section>

        <div class="w-full flex-center flex-col mt-120 lg:a-mt-80">
          <template v-if="!ifUser()">
            <router-link
              :to="{ path:'/register', name:'register', query: {redirect: '/index'} }"
              class="h-80 lg:a-h-50 text-32 lg:a-text-18 px-60 lg:a-px-30 flex-center font-medium rounded-full text-white hover:text-white bg-primary"
            >{{ t('member_index.common.register') }}</router-link>
            <p class="mt-60 lg:a-mt-32 mb-250 lg:a-mb-300 text-32 lg:a-text-18 text-#4D4D4D">
              <span class="mr-4 lg:a-mr-4">{{ t('member_index.common.already_a_member') }}</span>
              <router-link
                :to="{ path:'/login', name:'login', query: {redirect: '/index'} }"
                class="text-primary underline underline-offset-4 hover:(text-primary underline)"
              >{{ t('member_index.common.login') }}</router-link>
            </p>
          </template>
        </div>
    </div>
</template>
<script setup>
import { Fancybox } from "@fancyapps/ui"
import "@fancyapps/ui/dist/fancybox/fancybox.css"

import { cookie, } from "@u/common";

const { t } = useI18n()

const ifUser = () => Boolean(cookie.get("_jk_user") || localStorage.getItem('JACKERY_USER_TOKEN'))

const browserGo = () => {
  location.pathname === '/' && window.history.go(-1)
}

onMounted(() => {
  // PC 图片预览
  Fancybox.bind("#gallery [data-fancybox-pc]", {
    groupAll: true,
  })
  // MB 图片预览
  Fancybox.bind("#gallery [data-fancybox-mb]", {
    groupAll: true,
  })

  window.scrollTo({top: 0})
  // 监听浏览器返回
  window.addEventListener('popstate', browserGo, false)
});

onUnmounted(() => {
  window.removeEventListener('popstate', browserGo, false)
})
</script>

<style scoped>
.guide-step {
  @apply
    mt-150 lg:a-mt-160
}
.guide-step>h3 {
  @apply 
    px-80 lg:a-p-0 text-40 leading-40 lg:a-text-32 lg:a-leading-32 font-semibold text-black lg:text-sub mb-30 lg-a-mb-80
}
.guide-step>h5 {
  @apply
    px-80 lg:a-p-0 text-32 leading-32 lg:a-text-24 lg:a-leading-24 font-semibold text-black lg:text-sub mt-50 mb-30 lg:a-mt-0 lg-a-mb-16
}
.guide-step>p {
  @apply
    px-80 lg:a-p-0 text-28 leading-44 lg:a-text-18 lg:a-leading-26 font-normal text-sub lg:text-#4D4D4D
}
.guide-step>img {
  @apply
    w-full h-680 lg:a-w-800 lg:a-h-360 object-cover mt-50 mb-80 lg:a-my-30
}
.guide-step>p:last-of-type,
.guide-step>img:last-of-type {
  @apply
    !mb-0 !lg:a-mb-0
}
</style>
